import type { PresenceDictionary } from '../wcContracts'

const presence: PresenceDictionary = {
  history: { title: '公開済みコンテンツ', body: '企業の公開履歴と日付を確認できます。元のページを開いても、再公開は行われません。', publishedOn: '公開日：{date}', recordedPages: '件の公開済み URL', receptionLoading: '応対設定を読み込み中…', receptionUnavailable: '応対設定を読み込めませんでした。既存の Web コンテンツは下で確認できます。' },
  page: { title: 'プレゼンス', intro: 'コンテンツの公開先を確認し、対応が必要なタスクを完了します。' },
  overview: { officialSite: '公式サイト', searchSubmission: '検索登録申請', needsAction: '対応が必要', online: '公開中', submitted: '申請済み' },
  queue: { title: 'コンテンツタスク', all: 'すべて', needsAction: '要対応', inProgress: '処理中', published: '公開済み', taskCount: '{count} 件のタスク' },
  state: { manualPrepared: '手動手順を準備済み', reviewReady: '確認待ち', processing: '処理中', published: '公開済み' },
  manual: { title: '公開を完了する', noDuplicate: '重複投稿はありません。', fallbackBody: '自動公開が完了しなかったため、手動手順を準備しました。', copy: '準備済みコンテンツをコピー', openDestination: '公開先を開く', publicUrl: '公開後のURL', markPublished: '公開済みにする', saved: '公開済みとして保存しました。' },
  common: { websiteStatus: 'サイト状態', distribution: '配信', details: '公開詳細', technicalRecord: '技術記録を表示', demoData: 'デモデータ' },
  site: {
  "back": "ウェブサイト一覧",
  "switchSite": "サイトを切り替え",
  "single": "このプロジェクトの唯一のサイト",
  "navigation": "サイト管理",
  "manage": "サイトを管理",
  "manageAirlock": "Airlock を管理",
  "pageCount": "件の訪問者向けページ",
  "viewPages": "ページを見る",
  "todoCount": "対応が必要な受付タスク {count} 件",
  "languageBody": "サイトのコンテンツ言語は公開先に従い、画面言語では変わりません。",
  "pagesBody": "現在のサイト版のページと利用可能な受付形式です。設定は Airlock で行います。",
  "noBuild": "確認済みのサイト版はまだありません。生成・検証後にページが表示されます。",
  "machinePages": "機械可読ファイル",
  "readerPages": "訪問者向けページ",
  "machineNoSlot": "受付 UI は設置しません",
  "noSlot": "設置可能な場所はまだありません",
  "originalTodo": "元のタスクに戻りました",
  "todoUnavailable": "元のタスクは利用できません。このサイトの最新タスクをご確認ください。",
  "todoResolved": "このタスクは対応済みです。",
  "todoOpen": "このタスクは未完了です。資料の提出だけでは解決済みになりません。",
  "domain": "サイトのアドレス",
  "environmentLabel": "公開環境",
  "installation": "接続方式",
  "connected": "自動デプロイに接続済み",
  "guided": "手順に沿った設置が必要",
  "connectedBody": "承認済みの接続で公開します。公開前に対象と範囲を表示します。",
  "guidedBody": "対応する自動デプロイ接続がありません。Airlock の設置ガイドをご確認ください。ここから自動公開はできません。",
  "deployBoundary": "このページの閲覧で生成・デプロイ・モデル呼び出しは行いません。",
  "unavailable": "選択したサイトは利用できません。一覧から選んでください。別のサイトへの自動切り替えは行いません。",
  "connect": "既存サイトを接続",
  "create": "新しいサイトを作成",
  "emptyBody": "Airlock の有効化前にサイトを用意してください。公開先は推測しません。",
  "connectHelp": "接続にはサイトのアドレス、管理権限、対応する接続方式が必要です。セルフ設定は準備中のため、プロジェクト担当者に設定をご依頼ください。",
  "createHelp": "新規サイトには内容とホスティング先の確認が必要です。セルフ作成は準備中です。設定されたサイトはこの一覧に表示されます。",
  "tabs": {
    "overview": "概要",
    "pages": "ページと公開",
    "airlock": "Airlock",
    "deploy": "ドメインとデプロイ"
  },
  "environment": {
    "production": "本番",
    "staging": "テスト"
  },
  "airlockState": {
    "preparing": "準備中",
    "ready": "準備完了",
    "publishing": "公開中",
    "live": "受付中",
    "paused": "一時停止",
    "failed": "要対応"
  },
  "slot": {
    "widget": "フローティング受付",
    "inline": "ページ内受付",
    "focus": "専用受付"
  }
},
  material: {
  "pending_domain": "資料を受領しました。利用範囲の確認待ちで、受付用の知識にはまだ反映されていません。",
  "awaiting_knowledge_confirmation": "公開資料に分類されました。知識の整理・確認が必要で、受付には未同期です。",
  "private_only": "この資料は非公開のため対外回答に使えません。公開資料を追加するか、回答範囲を設定してください。",
  "synced": "承認済みの公開資料がこのプロジェクトの Airlock 知識に反映されました。Airlock に戻って再テストできます。",
  "loadError": "資料の進捗を取得できませんでした。未提出とは限りません。後ほど再度開いてください。",
  "addMore": "資料を追加"
},
  workspace: {
    loading: '許可済みサイトを読み込み中…', error: '最新のサイト状態を読み込めませんでした。', empty: '許可済みサイトまたは検証済み公開はまだありません。', authorisedSites: '件の許可済みサイト', verifiedRoutes: '件の検証済み公開経路', preservedIssues: '件の対応待ち問題', eyebrow: 'サイトワークスペース', title: '公開先と最新の検証済みリリース', siteCount: 'サイト {count} 件', mode: 'サイトモード', managedStatic: 'Navigator 管理の静的サイト', languages: '対応言語', lastDeploy: '最新リリース', machine: 'マシン層', noRelease: 'このサイトにはまだアクション公開がありません。',
    status: { configured: '設定済み', building: '構築中', ready: '公開可能', deploying: '配備中', state_unknown: '状態の検証が必要', live: '公開中', failed: '対応が必要' }, machineStatus: { pending: '準備中', verified: '検証済み', unknown: '不明 · 安全に停止', failed: '失敗' },
  },
}

export default presence
